import axios from "axios";
axios.defaults.baseURL = "https://api.powebapp.goodyear.com/api/";
